import { render } from "./FloodRelief.vue?vue&type=template&id=20cc6392&scoped=true"
import script from "./FloodRelief.vue?vue&type=script&lang=js"
export * from "./FloodRelief.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-20cc6392"

export default script